<template>
  <Dialog
    v-model:visible="internalVisible"
    :modal="true"
    :draggable="false"
    :header="$t('dialogs.request_training_dialog.request_training')"
    :style="{ width: '32rem' }"
    @hide="onHide"
  >
    <form @submit.prevent="submit" class="space-y-4">
      <div>
        <label for="trainingMessage" class="block text-sm font-medium">
          {{ $t('dialogs.request_training_dialog.training_message_label') }}
        </label>
        <Textarea
          id="trainingMessage"
          v-model="message"
          auto-resize
          rows="5"
          class="w-full mt-1"
          :maxlength="1000"
        />
        <p class="text-xs text-gray-500 mt-1">
          {{ message.length }}/1000
        </p>
        <p v-if="error" class="text-xs text-red-600 mt-1">
          {{ error }}
        </p>
      </div>

      <div class="flex justify-end space-x-2">
        <Button
          type="button"
          :label="$t('common.cancel')"
          class="p-button-text"
          :disabled="submitting"
          @click="close"
        />
        <Button
          type="submit"
          :disabled="submitting"
          :label="submitting ? $t('common.sending') : $t('common.send')"
        />
      </div>
    </form>
  </Dialog>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TrainingRequestDialog',
  props: {
    modelValue: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      internalVisible: this.modelValue,
      message: '',
      error: null,
      submitting: false
    };
  },
  watch: {
    modelValue(val) {
      this.internalVisible = val;
      if (val) {
        this.reset();
      }
    },
    internalVisible(val) {
      if (val !== this.modelValue) {
        this.$emit('update:modelValue', val);
      }
    }
  },
  methods: {
    reset() {
      this.message = '';
      this.error = null;
      this.submitting = false;
    },
    close() {
      this.internalVisible = false;
    },
    onHide() {
      // ensure parent sync
      this.$emit('update:modelValue', false);
    },
    async submit() {
      this.error = null;
      if (!this.message.trim()) {
        this.error = this.$t('dialogs.request_training_dialog.required');
        return;
      }
      this.submitting = true;
      try {
        await axios.post('/support/training-request', { message: this.message.trim() });
        this.$toast.add({
            severity: 'success',
            summary: this.$t('dialogs.request_training_dialog.request_training'),
            detail: this.$t('dialogs.request_training_dialog.training_request_sent'),
            life: 3000
        });
        this.close();
      } catch (e) {
        this.error = e.response?.data?.message || this.$t('errors.generic');
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>